export const GET_CONTACT_SUPPORT_LIST_ACTION = "GET_CONTACT_SUPPORT_LIST_ACTION"
export const GET_CONTACT_SUPPORT_LIST_LOADING = "GET_CONTACT_SUPPORT_LIST_LOADING"
export const GET_CONTACT_SUPPORT_LIST_ERROR = "GET_CONTACT_SUPPORT_LIST_ERROR"
export const GET_CONTACT_SUPPORT_LIST_SUCCESS = "GET_CONTACT_SUPPORT_LIST_SUCCESS"

export const CREATE_CONTACT_SUPPORT_REQUEST_ACTION = "CREATE_CONTACT_SUPPORT_REQUEST_ACTION"
export const CREATE_CONTACT_SUPPORT_REQUEST_LOADING = "CREATE_CONTACT_SUPPORT_REQUEST_LOADING"
export const CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS = "CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS"
export const CREATE_CONTACT_SUPPORT_REQUEST_ERROR = "CREATE_CONTACT_SUPPORT_REQUEST_ERROR"


export const ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION = "ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION"
export const ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING = "ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING"
export const ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR = "ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR"
export const ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS = "ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS"